import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import "./sectionSixThemeThree.css";

function SectionSixThemeThree() {
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const section = homedata?.theme_3?.home?.section_6;
  const collection: any[] = section?.card_section?.collection || [];

  const stepsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = stepsRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="s6how" id="how-work-section">
      {/* Coloured header band */}
      <div className="s6how__header">
        <div className="container">
          {section?.sub_heading_top && (
            <span className="s6how__eyebrow">{section.sub_heading_top}</span>
          )}
          <h2
            className="s6how__title"
            style={section?.h2color ? { color: `#${section.h2color}` } : undefined}
          >
            {section?.title}
          </h2>
          {section?.paragraph && (
            <p
              className="s6how__subtitle"
              style={section?.h2subcolor ? { color: `#${section.h2subcolor}` } : undefined}
            >
              {section.paragraph}
            </p>
          )}
        </div>
      </div>

      {/* Steps */}
      <div className="s6how__body">
        <div className="container">
          <div className="s6how__steps" ref={stepsRef}>
            {/* Animated progress track */}
            <div className="s6how__track">
              <div className="s6how__track-fill" />
            </div>

            {collection.map((item: any, index: number) => (
              <div className="s6how__step" key={index}>
                {/* Numbered dot */}
                <div className="s6how__dot">{index + 1}</div>

                {/* Image */}
                <div className="s6how__img">
                  <img src={item.icon} alt={item.card_title} />
                </div>

                {/* Text — wrapped so they group as one flex item on mobile */}
                <div className="s6how__step-content">
                  <h3
                    className="s6how__step-title"
                    style={section?.h3color ? { color: `#${section.h3color}` } : undefined}
                  >
                    {item.card_title}
                  </h3>
                  <p
                    className="s6how__step-para"
                    style={section?.paracolor ? { color: `#${section.paracolor}` } : undefined}
                  >
                    {item.card_paragraph}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionSixThemeThree;
